import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import { withTranslation } from 'react-i18next';
import LocationPairForm from './LocationPairForm';

class CreateLocationPairModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    locationPair: PropTypes.object,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  getLabel = () => {
    const { t } = this.props;
    if (!this.props.locationPair) {
      return t('CREATE_LOCATION_PAIR');
    }
    return t('EDIT_LOCATION_PAIR');
  };
  handleSave = (locationPair) => this.props.onSave(locationPair);

  handleHide = () => this.props.onHide();

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <h4>{this.getLabel()}</h4>
        </Modal.Header>
        <Modal.Body>
          <LocationPairForm
            locationPair={this.props.locationPair}
            onCancel={this.handleHide}
            onSave={this.handleSave}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(CreateLocationPairModal);
